import type { OdontogramItem } from "@/types/odontogram";

export const odontogramItems: OdontogramItem[] = [
    {
        id: 11,
        path: {
            all: 'm 457.6697,34.8341 v 51.0236 h 51.0236 V 34.8341 Z',
            occlusal: 'm 468.8949,60.2042 v 0.2835 h 28.5732 v -0.2835 z',
            distal: 'm 457.6697,74.6325 v 11.2252 l 11.2252,-25.6534 v 0 L 457.6697,34.8341 v 11.2252 z',
            mesial: 'M 508.6933,74.6325 V 85.8577 L 497.4681,60.4876 v -0.2833 l 11.2252,-25.3702 v 11.2252 z',
            lingual: 'm 497.4681,85.8577 h 11.2252 L 497.4681,60.4876 h -28.5732 l -11.2252,25.3701 h 11.2252 z',
            vestibular: 'm 497.4681,34.8341 h 11.2252 L 497.4681,60.2043 H 468.8949 L 457.6697,34.8341 h 11.2252 z',
        },
        cap: { x: '468.3017', y: '105.0021' },
        top: { x: '482.6373', y: '30.7647' },
    },
    {
        id: 12,
        path: {
            all: 'm 395.3075,34.8341 v 51.0236 h 51.0236 V 34.8341 Z',
            occlusal: 'm 406.5327,60.2042 v 0.2835 h 28.5732 v -0.2835 z',
            distal: 'm 395.3075,74.6325 v 11.2252 l 11.2252,-25.6534 v 0 L 395.3075,34.8341 v 11.2252 z',
            mesial: 'M 446.3311,74.6325 V 85.8577 L 435.1059,60.4876 v -0.2833 l 11.2252,-25.3702 v 11.2252 z',
            lingual: 'm 435.1059,85.8577 h 11.2252 L 435.1059,60.4876 h -28.5732 l -11.2252,25.3701 h 11.2252 z',
            vestibular: 'm 435.1059,34.8341 h 11.2252 L 435.1059,60.2043 H 406.5327 L 395.3075,34.8341 h 11.2252 z',
        },
        cap: { x: '403.42542', y: '105.0021' },
        top: { x: '420.27509', y: '30.7647' },
    },
    {
        id: 13,
        path: {
            all: 'm 332.9453,34.8341 v 51.0236 h 51.0236 V 34.8341 Z',
            occlusal: 'm 344.1705,60.2042 v 0.2835 h 28.5732 v -0.2835 z',
            distal: 'm 332.9453,74.6325 v 11.2252 l 11.2252,-25.6534 v 0 L 332.9453,34.8341 v 11.2252 z',
            mesial: 'M 383.9689,74.6325 V 85.8577 L 372.7437,60.4876 v -0.2833 l 11.2252,-25.3702 v 11.2252 z',
            lingual: 'm 372.7437,85.8577 h 11.2252 L 372.7437,60.4876 h -28.5732 l -11.2252,25.3701 h 11.2252 z',
            vestibular: 'm 372.7437,34.8341 h 11.2252 L 372.7437,60.2043 H 344.1705 L 332.9453,34.8341 h 11.2252 z',
        },
        cap: { x: '340.99109', y: '105.2181' },
        top: { x: '357.9129', y: '30.7647' },
    },
    {
        id: 14,
        path: {
            all: 'm 270.5831,34.8341 v 51.0236 h 51.0236 V 34.8341 Z',
            occlusal: 'm 281.8083,46.0593 v 28.5732 h 28.5732 V 46.0593 Z',
            distal: 'M 270.5831,74.6325 V 85.8577 L 281.8083,74.6325 V 46.0593 L 270.5831,34.8341 v 11.2252 z',
            mesial: 'M 321.6067,74.6325 V 85.8577 L 310.3815,74.6325 V 46.0593 l 11.2252,-11.2252 v 11.2252 z',
            lingual: 'm 310.3815,85.8577 h 11.2252 L 310.3815,74.6325 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            vestibular: 'm 310.3815,34.8341 h 11.2252 L 310.3815,46.0593 H 281.8083 L 270.5831,34.8341 h 11.2252 z',
        },
        cap: { x: '278.65601', y: '105.0021' },
        top: { x: '295.5506', y: '30.7647' },
    },
    {
        id: 15,
        path: {
            all: 'm 208.2209,34.8341 v 51.0236 h 51.0236 V 34.8341 Z',
            occlusal: 'm 219.4461,46.0593 v 28.5732 h 28.5732 V 46.0593 Z',
            distal: 'M 208.2209,74.6325 V 85.8577 L 219.4461,74.6325 V 46.0593 L 208.2209,34.8341 v 11.2252 z',
            mesial: 'M 259.2445,74.6325 V 85.8577 L 248.0193,74.6325 V 46.0593 l 11.2252,-11.2252 v 11.2252 z',
            lingual: 'm 248.0193,85.8577 h 11.2252 L 248.0193,74.6325 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            vestibular: 'm 248.0193,34.8341 h 11.2252 L 248.0193,46.0593 H 219.4461 L 208.2209,34.8341 h 11.2252 z',
        },
        cap: { x: '216.2218', y: '105.2181' },
        top: { x: '233.1884', y: '30.7647' },
    },
    {
        id: 16,
        path: {
            all: 'm 145.8587,34.8341 v 51.0236 h 51.0236 V 34.8341 Z',
            occlusal: 'm 157.0839,46.0593 v 28.5732 h 28.5732 V 46.0593 Z',
            distal: 'M 145.8587,74.6325 V 85.8577 L 157.0839,74.6325 V 46.0593 L 145.8587,34.8341 v 11.2252 z',
            mesial: 'M 196.8823,74.6325 V 85.8577 L 185.6571,74.6325 V 46.0593 l 11.2252,-11.2252 v 11.2252 z',
            lingual: 'm 185.6571,85.8577 h 11.2252 L 185.6571,74.6325 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            vestibular: 'm 185.6571,34.8341 h 11.2252 L 185.6571,46.0593 H 157.0839 L 145.8587,34.8341 h 11.2252 z',
        },
        cap: { x: '153.9045', y: '105.2181' },
        top: { x: '170.8262', y: '30.7647' },
    },
    {
        id: 17,
        path: {
            all: 'm 83.4965,34.8341 v 51.0236 h 51.0236 V 34.8341 Z',
            occlusal: 'm 94.7217,46.0593 v 28.5732 h 28.5732 V 46.0593 Z',
            distal: 'M 83.4965,74.6325 V 85.8577 L 94.7217,74.6325 V 46.0593 L 83.4965,34.8341 v 11.2252 z',
            mesial: 'M 134.5201,74.6325 V 85.8577 L 123.2949,74.6325 V 46.0593 l 11.2252,-11.2252 v 11.2252 z',
            lingual: 'm 123.2949,85.8577 h 11.2252 L 123.2949,74.6325 H 94.7217 L 83.4965,85.8577 h 11.2252 z',
            vestibular: 'm 123.2949,34.8341 h 11.2252 L 123.2949,46.0593 H 94.7217 L 83.4965,34.8341 h 11.2252 z',
        },
        cap: { x: '91.551399', y: '105.0021' },
        top: { x: '108.464', y: '30.7647' },
    },
    {
        id: 18,
        path: {
            all: 'M 21.1343,34.8341 V 85.8577 H 72.1579 V 34.8341 Z',
            occlusal: 'M 32.3595,46.0593 V 74.6325 H 60.9327 V 46.0593 Z',
            distal: 'M 21.1343,74.6325 V 85.8577 L 32.3595,74.6325 V 46.0593 L 21.1343,34.8341 v 11.2252 z',
            mesial: 'M 72.1579,74.6325 V 85.8577 L 60.9327,74.6325 V 46.0593 L 72.1579,34.8341 v 11.2252 z',
            lingual: 'M 60.9327,85.8577 H 72.1579 L 60.9327,74.6325 H 32.3595 L 21.1343,85.8577 h 11.2252 z',
            vestibular: 'M 60.9327,34.8341 H 72.1579 L 60.9327,46.0593 H 32.3595 L 21.1343,34.8341 h 11.2252 z',
        },
        cap: { x: '29.1712', y: '105.2181' },
        top: { x: '46.101799', y: '30.7647' },
    },
    {
        id: 21,
        path: {
            all: 'm 520.7091,34.8341 v 51.0236 h 51.0236 V 34.8341 Z',
            occlusal: 'm 531.9343,60.2042 v 0.2835 h 28.5732 v -0.2835 z',
            mesial: 'm 520.7091,74.6325 v 11.2252 l 11.2252,-25.6534 v 0 L 520.7091,34.8341 v 11.2252 z',
            distal: 'M 571.7327,74.6325 V 85.8577 L 560.5075,60.4876 v -0.2833 l 11.2252,-25.3702 v 11.2252 z',
            lingual: 'm 560.5075,85.8577 h 11.2252 L 560.5075,60.4876 h -28.5732 l -11.2252,25.3701 h 11.2252 z',
            vestibular: 'm 560.5075,34.8341 h 11.2252 L 560.5075,60.2043 H 531.9343 L 520.7091,34.8341 h 11.2252 z',
        },
        cap: { x: '527.85492', y: '105.0021' },
        top: { x: '545.67657', y: '30.7647' },
    },
    {
        id: 22,
        path: {
            all: 'm 583.0713,34.8341 v 51.0236 h 51.0236 V 34.8341 Z',
            occlusal: 'm 594.2965,60.2042 v 0.2835 h 28.5732 v -0.2835 z',
            mesial: 'm 583.0713,74.6325 v 11.2252 l 11.2252,-25.6534 v 0 L 583.0713,34.8341 v 11.2252 z',
            distal: 'M 634.0949,74.6325 V 85.8577 L 622.8697,60.4876 v -0.2833 l 11.2252,-25.3702 v 11.2252 z',
            lingual: 'm 622.8697,85.8577 h 11.2252 L 622.8697,60.4876 h -28.5732 l -11.2252,25.3701 h 11.2252 z',
            vestibular: 'm 622.8697,34.8341 h 11.2252 L 622.8697,60.2043 H 594.2965 L 583.0713,34.8341 h 11.2252 z',
        },
        cap: { x: '589.03809', y: '105.0021' },
        top: { x: '608.03882', y: '30.7647' },
    },
    {
        id: 23,
        path: {
            all: 'm 645.4335,34.8341 v 51.0236 h 51.0236 V 34.8341 Z',
            occlusal: 'm 656.6587,60.2042 v 0.2835 h 28.5732 v -0.2835 z',
            mesial: 'm 645.4335,74.6325 v 11.2252 l 11.2252,-25.6534 v 0 L 645.4335,34.8341 v 11.2252 z',
            distal: 'M 696.4571,74.6325 V 85.8577 L 685.2319,60.4876 v -0.2833 l 11.2252,-25.3702 v 11.2252 z',
            lingual: 'm 685.2319,85.8577 h 11.2252 L 685.2319,60.4876 h -28.5732 l -11.2252,25.3701 h 11.2252 z',
            vestibular: 'm 685.2319,34.8341 h 11.2252 L 685.2319,60.2043 H 656.6587 L 645.4335,34.8341 h 11.2252 z',
        },
        cap: { x: '651.32831', y: '105.2181' },
        top: { x: '670.401', y: '30.7647' },
    },
    {
        id: 24,
        path: {
            all: 'm 707.7957,34.8341 v 51.0236 h 51.0236 V 34.8341 Z',
            occlusal: 'm 719.0209,46.0593 v 28.5732 h 28.5732 V 46.0593 Z',
            mesial: 'M 707.7957,74.6325 V 85.8577 L 719.0209,74.6325 V 46.0593 L 707.7957,34.8341 v 11.2252 z',
            distal: 'M 758.8193,74.6325 V 85.8577 L 747.5941,74.6325 V 46.0593 l 11.2252,-11.2252 v 11.2252 z',
            lingual: 'm 747.5941,85.8577 h 11.2252 L 747.5941,74.6325 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            vestibular: 'm 747.5941,34.8341 h 11.2252 L 747.5941,46.0593 H 719.0209 L 707.7957,34.8341 h 11.2252 z',
        },
        cap: { x: '713.71753', y: '105.0021' },
        top: { x: '732.76318', y: '30.7647' },
    },
    {
        id: 25,
        path: {
            all: 'm 770.1579,34.8341 v 51.0236 h 51.0236 V 34.8341 Z',
            occlusal: 'm 781.3831,46.0593 v 28.5732 h 28.5732 V 46.0593 Z',
            mesial: 'M 770.1579,74.6325 V 85.8577 L 781.3831,74.6325 V 46.0593 L 770.1579,34.8341 v 11.2252 z',
            distal: 'M 821.1815,74.6325 V 85.8577 L 809.9563,74.6325 V 46.0593 l 11.2252,-11.2252 v 11.2252 z',
            lingual: 'm 809.9563,85.8577 h 11.2252 L 809.9563,74.6325 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            vestibular: 'm 809.9563,34.8341 h 11.2252 L 809.9563,46.0593 H 781.3831 L 770.1579,34.8341 h 11.2252 z',
        },
        cap: { x: '776.00769', y: '105.2181' },
        top: { x: '795.12543', y: '30.7647' },
    },
    {
        id: 26,
        path: {
            all: 'm 832.5201,34.8341 v 51.0236 h 51.0236 V 34.8341 Z',
            occlusal: 'm 843.7453,46.0593 v 28.5732 h 28.5732 V 46.0593 Z',
            mesial: 'M 832.5201,74.6325 V 85.8577 L 843.7453,74.6325 V 46.0593 L 832.5201,34.8341 v 11.2252 z',
            distal: 'M 883.5437,74.6325 V 85.8577 L 872.3185,74.6325 V 46.0593 l 11.2252,-11.2252 v 11.2252 z',
            lingual: 'm 872.3185,85.8577 h 11.2252 L 872.3185,74.6325 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            vestibular: 'm 872.3185,34.8341 h 11.2252 L 872.3185,46.0593 H 843.7453 L 832.5201,34.8341 h 11.2252 z',
        },
        cap: { x: '838.41492', y: '105.2181' },
        top: { x: '857.48767', y: '30.7647' },
    },
    {
        id: 27,
        path: {
            all: 'm 894.8823,34.8341 v 51.0236 h 51.0236 V 34.8341 Z',
            occlusal: 'm 906.1075,46.0593 v 28.5732 h 28.5732 V 46.0593 Z',
            mesial: 'M 894.8823,74.6325 V 85.8577 L 906.1075,74.6325 V 46.0593 L 894.8823,34.8341 v 11.2252 z',
            distal: 'M 945.9059,74.6325 V 85.8577 L 934.6807,74.6325 V 46.0593 l 11.2252,-11.2252 v 11.2252 z',
            lingual: 'm 934.6807,85.8577 h 11.2252 L 934.6807,74.6325 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            vestibular: 'm 934.6807,34.8341 h 11.2252 L 934.6807,46.0593 H 906.1075 L 894.8823,34.8341 h 11.2252 z',
        },
        cap: { x: '900.78619', y: '105.0021' },
        top: { x: '919.84991', y: '30.7647' },
    },
    {
        id: 28,
        path: {
            all: 'm 957.2445,34.8341 v 51.0236 h 51.0236 V 34.8341 Z',
            occlusal: 'm 968.4697,46.0593 v 28.5732 h 28.5732 V 46.0593 Z',
            mesial: 'M 957.2445,74.6325 V 85.8577 L 968.4697,74.6325 V 46.0593 L 957.2445,34.8341 v 11.2252 z',
            distal: 'M 1008.2681,74.6325 V 85.8577 L 997.0429,74.6325 V 46.0593 l 11.2252,-11.2252 v 11.2252 z',
            lingual: 'm 997.0429,85.8577 h 11.2252 l -11.2252,-11.2252 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            vestibular: 'm 997.0429,34.8341 h 11.2252 l -11.2252,11.2252 H 968.4697 L 957.2445,34.8341 h 11.2252 z',
        },
        cap: { x: '963.13037', y: '105.2181' },
        top: { x: '982.2121', y: '30.7647' },
    },
    {
        id: 31,
        path: {
            all: 'm 520.7091,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 531.9343,400.3617 v 0.2834 h 28.5732 v -0.2834 z',
            mesial: 'm 520.7091,414.79 v 11.2252 l 11.2252,-25.6534 v 0 l -11.2252,-25.3702 v 11.2252 z',
            distal: 'm 571.7327,414.79 v 11.2252 L 560.5075,400.645 v -0.2832 l 11.2252,-25.3702 v 11.2252 z',
            vestibular: 'm 560.5075,426.0152 h 11.2252 L 560.5075,400.645 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            lingual: 'm 560.5075,374.9916 h 11.2252 l -11.2252,25.3702 h -28.5732 l -11.2252,-25.3702 h 11.2252 z',
        },
        cap: { x: '528.224', y: '445.37561' },
        top: { x: '545.67657', y: '370.92221' },
    },
    {
        id: 32,
        path: {
            all: 'm 583.0713,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 594.2965,400.3617 v 0.2834 h 28.5732 v -0.2834 z',
            mesial: 'm 583.0713,414.79 v 11.2252 l 11.2252,-25.6534 v 0 l -11.2252,-25.3702 v 11.2252 z',
            distal: 'm 634.0949,414.79 v 11.2252 L 622.8697,400.645 v -0.2832 l 11.2252,-25.3702 v 11.2252 z',
            vestibular: 'm 622.8697,426.0152 h 11.2252 L 622.8697,400.645 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            lingual: 'm 622.8697,374.9916 h 11.2252 l -11.2252,25.3702 h -28.5732 l -11.2252,-25.3702 h 11.2252 z',
        },
        cap: { x: '589.4071', y: '445.37561' },
        top: { x: '608.03882', y: '370.92221' },
    },
    {
        id: 33,
        path: {
            all: 'm 645.4335,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 656.6587,400.3617 v 0.2834 h 28.5732 v -0.2834 z',
            mesial: 'm 645.4335,414.79 v 11.2252 l 11.2252,-25.6534 v 0 l -11.2252,-25.3702 v 11.2252 z',
            distal: 'm 696.4571,414.79 v 11.2252 L 685.2319,400.645 v -0.2832 l 11.2252,-25.3702 v 11.2252 z',
            vestibular: 'm 685.2319,426.0152 h 11.2252 L 685.2319,400.645 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            lingual: 'm 685.2319,374.9916 h 11.2252 l -11.2252,25.3702 h -28.5732 l -11.2252,-25.3702 h 11.2252 z',
        },
        cap: { x: '651.69733', y: '445.37561' },
        top: { x: '670.401', y: '370.92221' },
    },
    {
        id: 34,
        path: {
            all: 'm 707.7957,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'M 719.0209,386.2168 V 414.79 h 28.5732 v -28.5732 z',
            mesial: 'm 707.7957,414.79 v 11.2252 L 719.0209,414.79 v -28.5732 l -11.2252,-11.2252 v 11.2252 z',
            distal: 'm 758.8193,414.79 v 11.2252 L 747.5941,414.79 v -28.5732 l 11.2252,-11.2252 v 11.2252 z',
            vestibular: 'm 747.5941,426.0152 h 11.2252 L 747.5941,414.79 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            lingual: 'm 747.5941,374.9916 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '713.08661', y: '445.37561' },
        top: { x: '732.76318', y: '370.92221' },
    },
    {
        id: 35,
        path: {
            all: 'm 770.1579,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'M 781.3831,386.2168 V 414.79 h 28.5732 v -28.5732 z',
            mesial: 'm 770.1579,414.79 v 11.2252 L 781.3831,414.79 v -28.5732 l -11.2252,-11.2252 v 11.2252 z',
            distal: 'm 821.1815,414.79 v 11.2252 L 809.9563,414.79 v -28.5732 l 11.2252,-11.2252 v 11.2252 z',
            vestibular: 'm 809.9563,426.0152 h 11.2252 L 809.9563,414.79 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            lingual: 'm 809.9563,374.9916 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '776.37677', y: '445.37561' },
        top: { x: '795.12543', y: '370.92221' },
    },
    {
        id: 36,
        path: {
            all: 'm 832.5201,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'M 843.7453,386.2168 V 414.79 h 28.5732 v -28.5732 z',
            mesial: 'm 832.5201,414.79 v 11.2252 L 843.7453,414.79 v -28.5732 l -11.2252,-11.2252 v 11.2252 z',
            distal: 'm 883.5437,414.79 v 11.2252 L 872.3185,414.79 v -28.5732 l 11.2252,-11.2252 v 11.2252 z',
            vestibular: 'm 872.3185,426.0152 h 11.2252 L 872.3185,414.79 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            lingual: 'm 872.3185,374.9916 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '838.784', y: '445.37561' },
        top: { x: '857.48767', y: '370.92221' },
    },
    {
        id: 37,
        path: {
            all: 'm 894.8823,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'M 906.1075,386.2168 V 414.79 h 28.5732 v -28.5732 z',
            mesial: 'm 894.8823,414.79 v 11.2252 L 906.1075,414.79 v -28.5732 l -11.2252,-11.2252 v 11.2252 z',
            distal: 'm 945.9059,414.79 v 11.2252 L 934.6807,414.79 v -28.5732 l 11.2252,-11.2252 v 11.2252 z',
            vestibular: 'm 934.6807,426.0152 h 11.2252 L 934.6807,414.79 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            lingual: 'm 934.6807,374.9916 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '901.15521', y: '445.37561' },
        top: { x: '919.84991', y: '370.92221' },
    },
    {
        id: 38,
        path: {
            all: 'm 957.2445,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'M 968.4697,386.2168 V 414.79 h 28.5732 v -28.5732 z',
            mesial: 'm 957.2445,414.79 v 11.2252 L 968.4697,414.79 v -28.5732 l -11.2252,-11.2252 v 11.2252 z',
            distal: 'm 1008.2681,414.79 v 11.2252 L 997.0429,414.79 v -28.5732 l 11.2252,-11.2252 v 11.2252 z',
            vestibular: 'm 997.0429,426.0152 h 11.2252 L 997.0429,414.79 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            lingual: 'm 997.0429,374.9916 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '963.49939', y: '445.37561' },
        top: { x: '982.2121', y: '370.92221' },
    },
    {
        id: 41,
        path: {
            all: 'm 457.6697,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 468.8949,400.3617 v 0.2834 h 28.5732 v -0.2834 z',
            distal: 'm 457.6697,414.79 v 11.2252 l 11.2252,-25.6534 v 0 l -11.2252,-25.3702 v 11.2252 z',
            mesial: 'm 508.6933,414.79 v 11.2252 L 497.4681,400.645 v -0.2832 l 11.2252,-25.3702 v 11.2252 z',
            vestibular: 'm 497.4681,426.0152 h 11.2252 L 497.4681,400.645 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            lingual: 'm 497.4681,374.9916 h 11.2252 l -11.2252,25.3702 h -28.5732 l -11.2252,-25.3702 h 11.2252 z',
        },
        cap: { x: '464.3746', y: '445.15961' },
        top: { x: '482.6373', y: '370.92221' },
    },
    {
        id: 42,
        path: {
            all: 'm 395.3075,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 406.5327,400.3617 v 0.2834 h 28.5732 v -0.2834 z',
            distal: 'm 395.3075,414.79 v 11.2252 l 11.2252,-25.6534 v 0 l -11.2252,-25.3702 v 11.2252 z',
            mesial: 'm 446.3311,414.79 v 11.2252 L 435.1059,400.645 v -0.2832 l 11.2252,-25.3702 v 11.2252 z',
            vestibular: 'm 435.1059,426.0152 h 11.2252 L 435.1059,400.645 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            lingual: 'm 435.1059,374.9916 h 11.2252 l -11.2252,25.3702 h -28.5732 l -11.2252,-25.3702 h 11.2252 z',
        },
        cap: { x: '400.8334', y: '445.15961' },
        top: { x: '420.27509', y: '370.92221' },
    },
    {
        id: 43,
        path: {
            all: 'm 332.9453,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 344.1705,400.3617 v 0.2834 h 28.5732 v -0.2834 z',
            distal: 'm 332.9453,414.79 v 11.2252 l 11.2252,-25.6534 v 0 l -11.2252,-25.3702 v 11.2252 z',
            mesial: 'm 383.9689,414.79 v 11.2252 L 372.7437,400.645 v -0.2832 l 11.2252,-25.3702 v 11.2252 z',
            vestibular: 'm 372.7437,426.0152 h 11.2252 L 372.7437,400.645 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            lingual: 'm 372.7437,374.9916 h 11.2252 l -11.2252,25.3702 h -28.5732 l -11.2252,-25.3702 h 11.2252 z',
        },
        cap: { x: '338.39911', y: '445.37561' },
        top: { x: '357.9129', y: '370.92221' },
    },
    {
        id: 44,
        path: {
            all: 'm 270.5831,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'M 281.8083,386.2168 V 414.79 h 28.5732 v -28.5732 z',
            distal: 'm 270.5831,414.79 v 11.2252 L 281.8083,414.79 v -28.5732 l -11.2252,-11.2252 v 11.2252 z',
            mesial: 'm 321.6067,414.79 v 11.2252 L 310.3815,414.79 v -28.5732 l 11.2252,-11.2252 v 11.2252 z',
            vestibular: 'm 310.3815,426.0152 h 11.2252 L 310.3815,414.79 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            lingual: 'm 310.3815,374.9916 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '276.064', y: '445.15961' },
        top: { x: '295.5506', y: '370.92221' },
    },
    {
        id: 45,
        path: {
            all: 'm 208.2209,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'M 219.4461,386.2168 V 414.79 h 28.5732 v -28.5732 z',
            distal: 'm 208.2209,414.79 v 11.2252 L 219.4461,414.79 v -28.5732 l -11.2252,-11.2252 v 11.2252 z',
            mesial: 'm 259.2445,414.79 v 11.2252 L 248.0193,414.79 v -28.5732 l 11.2252,-11.2252 v 11.2252 z',
            vestibular: 'm 248.0193,426.0152 h 11.2252 L 248.0193,414.79 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            lingual: 'm 248.0193,374.9916 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '213.62981', y: '445.37561' },
        top: { x: '233.1884', y: '370.92221' },
    },
    {
        id: 46,
        path: {
            all: 'm 145.8587,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'M 157.0839,386.2168 V 414.79 h 28.5732 v -28.5732 z',
            distal: 'm 145.8587,414.79 v 11.2252 L 157.0839,414.79 v -28.5732 l -11.2252,-11.2252 v 11.2252 z',
            mesial: 'm 196.8823,414.79 v 11.2252 L 185.6571,414.79 v -28.5732 l 11.2252,-11.2252 v 11.2252 z',
            vestibular: 'm 185.6571,426.0152 h 11.2252 L 185.6571,414.79 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            lingual: 'm 185.6571,374.9916 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '151.3125', y: '445.37561' },
        top: { x: '170.8262', y: '370.92221' },
    },
    {
        id: 47,
        path: {
            all: 'm 83.4965,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'M 94.7217,386.2168 V 414.79 h 28.5732 v -28.5732 z',
            distal: 'm 83.4965,414.79 v 11.2252 L 94.7217,414.79 V 386.2168 L 83.4965,374.9916 v 11.2252 z',
            mesial: 'm 134.5201,414.79 v 11.2252 L 123.2949,414.79 v -28.5732 l 11.2252,-11.2252 v 11.2252 z',
            vestibular: 'm 123.2949,426.0152 h 11.2252 L 123.2949,414.79 H 94.7217 l -11.2252,11.2252 h 11.2252 z',
            lingual: 'm 123.2949,374.9916 h 11.2252 l -11.2252,11.2252 H 94.7217 L 83.4965,374.9916 h 11.2252 z',
        },
        cap: { x: '88.959396', y: '445.15961' },
        top: { x: '108.464', y: '370.92221' },
    },
    {
        id: 48,
        path: {
            all: 'm 21.1343,374.9916 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'M 32.3595,386.2168 V 414.79 h 28.5732 v -28.5732 z',
            distal: 'm 21.1343,414.79 v 11.2252 L 32.3595,414.79 V 386.2168 L 21.1343,374.9916 v 11.2252 z',
            mesial: 'm 72.1579,414.79 v 11.2252 L 60.9327,414.79 v -28.5732 l 11.2252,-11.2252 v 11.2252 z',
            vestibular: 'M 60.9327,426.0152 H 72.1579 L 60.9327,414.79 H 32.3595 l -11.2252,11.2252 h 11.2252 z',
            lingual: 'M 60.9327,374.9916 H 72.1579 L 60.9327,386.2168 H 32.3595 L 21.1343,374.9916 h 11.2252 z',
        },
        cap: { x: '26.579201', y: '445.37561' },
        top: { x: '46.101799', y: '370.92221' },
    },
    {
        id: 51,
        path: {
            all: 'm 457.6697,148.2199 v 51.0237 h 51.0236 v -51.0237 z',
            occlusal: 'm 468.8949,173.59 v 0.2835 h 28.5732 V 173.59 Z',
            distal: 'm 457.6697,188.0184 v 11.2252 l 11.2252,-25.6535 v 0 l -11.2252,-25.3702 v 11.2252 z',
            mesial: 'm 508.6933,188.0184 v 11.2252 l -11.2252,-25.3702 v -0.2833 l 11.2252,-25.3702 v 11.2252 z',
            lingual: 'm 497.4681,199.2436 h 11.2252 l -11.2252,-25.3702 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            vestibular: 'm 497.4681,148.2199 h 11.2252 l -11.2252,25.3702 h -28.5732 l -11.2252,-25.3702 h 11.2252 z',
        },
        cap: { x: '465.1846', y: '218.6039' },
        top: { x: '482.6373', y: '144.1505' },
    },
    {
        id: 52,
        path: {
            all: 'm 395.3075,148.2199 v 51.0237 h 51.0236 v -51.0237 z',
            occlusal: 'm 406.5327,173.59 v 0.2835 h 28.5732 V 173.59 Z',
            distal: 'm 395.3075,188.0184 v 11.2252 l 11.2252,-25.6535 v 0 l -11.2252,-25.3702 v 11.2252 z',
            mesial: 'm 446.3311,188.0184 v 11.2252 l -11.2252,-25.3702 v -0.2833 l 11.2252,-25.3702 v 11.2252 z',
            lingual: 'm 435.1059,199.2436 h 11.2252 l -11.2252,-25.3702 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            vestibular: 'm 435.1059,148.2199 h 11.2252 l -11.2252,25.3702 h -28.5732 l -11.2252,-25.3702 h 11.2252 z',
        },
        cap: { x: '401.6434', y: '218.6039' },
        top: { x: '420.27509', y: '144.1505' },
    },
    {
        id: 53,
        path: {
            all: 'm 332.9453,148.2199 v 51.0237 h 51.0236 v -51.0237 z',
            occlusal: 'm 344.1705,173.59 v 0.2835 h 28.5732 V 173.59 Z',
            distal: 'm 332.9453,188.0184 v 11.2252 l 11.2252,-25.6535 v 0 l -11.2252,-25.3702 v 11.2252 z',
            mesial: 'm 383.9689,188.0184 v 11.2252 l -11.2252,-25.3702 v -0.2833 l 11.2252,-25.3702 v 11.2252 z',
            lingual: 'm 372.7437,199.2436 h 11.2252 l -11.2252,-25.3702 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            vestibular: 'm 372.7437,148.2199 h 11.2252 l -11.2252,25.3702 h -28.5732 l -11.2252,-25.3702 h 11.2252 z',
        },
        cap: { x: '339.20911', y: '218.6039' },
        top: { x: '357.9129', y: '144.1505' },
    },
    {
        id: 54,
        path: {
            all: 'm 270.5831,148.2199 v 51.0237 h 51.0236 v -51.0237 z',
            occlusal: 'm 281.8083,159.4451 v 28.5733 h 28.5732 v -28.5733 z',
            distal: 'm 270.5831,188.0184 v 11.2252 l 11.2252,-11.2252 v -28.5733 l -11.2252,-11.2252 v 11.2252 z',
            mesial: 'm 321.6067,188.0184 v 11.2252 l -11.2252,-11.2252 v -28.5733 l 11.2252,-11.2252 v 11.2252 z',
            lingual: 'm 310.3815,199.2436 h 11.2252 l -11.2252,-11.2252 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            vestibular: 'm 310.3815,148.2199 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '276.87399', y: '218.6039' },
        top: { x: '295.5506', y: '144.1505' },
    },
    {
        id: 55,
        path: {
            all: 'm 208.2209,148.2199 v 51.0237 h 51.0236 v -51.0237 z',
            occlusal: 'm 219.4461,159.4451 v 28.5733 h 28.5732 v -28.5733 z',
            distal: 'm 208.2209,188.0184 v 11.2252 l 11.2252,-11.2252 v -28.5733 l -11.2252,-11.2252 v 11.2252 z',
            mesial: 'm 259.2445,188.0184 v 11.2252 l -11.2252,-11.2252 v -28.5733 l 11.2252,-11.2252 v 11.2252 z',
            lingual: 'm 248.0193,199.2436 h 11.2252 l -11.2252,-11.2252 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            vestibular: 'm 248.0193,148.2199 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '214.4398', y: '218.6039' },
        top: { x: '233.1884', y: '144.1505' },
    },
    {
        id: 61,
        path: {
            all: 'm 520.7091,148.2199 v 51.0237 h 51.0236 v -51.0237 z',
            occlusal: 'm 531.9343,173.59 v 0.2835 h 28.5732 V 173.59 Z',
            mesial: 'm 520.7091,188.0184 v 11.2252 l 11.2252,-25.6535 v 0 l -11.2252,-25.3702 v 11.2252 z',
            distal: 'm 571.7327,188.0184 v 11.2252 l -11.2252,-25.3702 v -0.2833 l 11.2252,-25.3702 v 11.2252 z',
            lingual: 'm 560.5075,199.2436 h 11.2252 l -11.2252,-25.3702 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            vestibular: 'm 560.5075,148.2199 h 11.2252 l -11.2252,25.3702 h -28.5732 l -11.2252,-25.3702 h 11.2252 z',
        },
        cap: { x: '528.11603', y: '218.6039' },
        top: { x: '545.67657', y: '144.1505' },
    },
    {
        id: 62,
        path: {
            all: 'm 583.0713,148.2199 v 51.0237 h 51.0236 v -51.0237 z',
            occlusal: 'm 594.2965,173.59 v 0.2835 h 28.5732 V 173.59 Z',
            mesial: 'm 583.0713,188.0184 v 11.2252 l 11.2252,-25.6535 v 0 l -11.2252,-25.3702 v 11.2252 z',
            distal: 'm 634.0949,188.0184 v 11.2252 l -11.2252,-25.3702 v -0.2833 l 11.2252,-25.3702 v 11.2252 z',
            lingual: 'm 622.8697,199.2436 h 11.2252 l -11.2252,-25.3702 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            vestibular: 'm 622.8697,148.2199 h 11.2252 l -11.2252,25.3702 h -28.5732 l -11.2252,-25.3702 h 11.2252 z',
        },
        cap: { x: '589.29907', y: '218.6039' },
        top: { x: '608.03882', y: '144.1505' },
    },
    {
        id: 63,
        path: {
            all: 'm 645.4335,148.2199 v 51.0237 h 51.0236 v -51.0237 z',
            occlusal: 'm 656.6587,173.59 v 0.2835 h 28.5732 V 173.59 Z',
            mesial: 'm 645.4335,188.0184 v 11.2252 l 11.2252,-25.6535 v 0 l -11.2252,-25.3702 v 11.2252 z',
            distal: 'm 696.4571,188.0184 v 11.2252 l -11.2252,-25.3702 v -0.2833 l 11.2252,-25.3702 v 11.2252 z',
            lingual: 'm 685.2319,199.2436 h 11.2252 l -11.2252,-25.3702 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            vestibular: 'm 685.2319,148.2199 h 11.2252 l -11.2252,25.3702 h -28.5732 l -11.2252,-25.3702 h 11.2252 z',
        },
        cap: { x: '651.58929', y: '218.6039' },
        top: { x: '670.401', y: '144.1505' },
    },
    {
        id: 64,
        path: {
            all: 'm 707.7957,148.2199 v 51.0237 h 51.0236 v -51.0237 z',
            occlusal: 'm 719.0209,159.4451 v 28.5733 h 28.5732 v -28.5733 z',
            mesial: 'm 707.7957,188.0184 v 11.2252 l 11.2252,-11.2252 v -28.5733 l -11.2252,-11.2252 v 11.2252 z',
            distal: 'm 758.8193,188.0184 v 11.2252 l -11.2252,-11.2252 v -28.5733 l 11.2252,-11.2252 v 11.2252 z',
            lingual: 'm 747.5941,199.2436 h 11.2252 l -11.2252,-11.2252 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            vestibular: 'm 747.5941,148.2199 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '713.97858', y: '218.6039' },
        top: { x: '732.76318', y: '144.1505' },
    },
    {
        id: 65,
        path: {
            all: 'm 770.1579,148.2199 v 51.0237 h 51.0236 v -51.0237 z',
            occlusal: 'm 781.3831,159.4451 v 28.5733 h 28.5732 v -28.5733 z',
            mesial: 'm 770.1579,188.0184 v 11.2252 l 11.2252,-11.2252 v -28.5733 l -11.2252,-11.2252 v 11.2252 z',
            distal: 'm 821.1815,188.0184 v 11.2252 l -11.2252,-11.2252 v -28.5733 l 11.2252,-11.2252 v 11.2252 z',
            lingual: 'm 809.9563,199.2436 h 11.2252 l -11.2252,-11.2252 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            vestibular: 'm 809.9563,148.2199 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '776.2688', y: '218.6039' },
        top: { x: '795.12543', y: '144.1505' },
    },
    {
        id: 71,
        path: {
            all: 'm 520.7091,261.6058 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 531.9343,286.9758 v 0.2835 h 28.5732 v -0.2835 z',
            mesial: 'm 520.7091,301.4042 v 11.2252 l 11.2252,-25.6535 v 0 l -11.2252,-25.3701 v 11.2252 z',
            distal: 'm 571.7327,301.4042 v 11.2252 l -11.2252,-25.3702 v -0.2833 l 11.2252,-25.3701 v 11.2252 z',
            vestibular: 'm 560.5075,312.6294 h 11.2252 l -11.2252,-25.3702 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            lingual: 'm 560.5075,261.6058 h 11.2252 l -11.2252,25.3701 h -28.5732 l -11.2252,-25.3701 h 11.2252 z',
        },
        cap: { x: '528.35919', y: '331.77371' },
        top: { x: '545.67657', y: '257.53629' },
    },
    {
        id: 72,
        path: {
            all: 'm 583.0713,261.6058 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 594.2965,286.9758 v 0.2835 h 28.5732 v -0.2835 z',
            mesial: 'm 583.0713,301.4042 v 11.2252 l 11.2252,-25.6535 v 0 l -11.2252,-25.3701 v 11.2252 z',
            distal: 'm 634.0949,301.4042 v 11.2252 l -11.2252,-25.3702 v -0.2833 l 11.2252,-25.3701 v 11.2252 z',
            vestibular: 'm 622.8697,312.6294 h 11.2252 l -11.2252,-25.3702 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            lingual: 'm 622.8697,261.6058 h 11.2252 l -11.2252,25.3701 h -28.5732 l -11.2252,-25.3701 h 11.2252 z',
        },
        cap: { x: '589.5423', y: '331.77371' },
        top: { x: '608.03882', y: '257.53629' },
    },
    {
        id: 73,
        path: {
            all: 'm 645.4335,261.6058 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 656.6587,286.9758 v 0.2835 h 28.5732 v -0.2835 z',
            mesial: 'm 645.4335,301.4042 v 11.2252 l 11.2252,-25.6535 v 0 l -11.2252,-25.3701 v 11.2252 z',
            distal: 'm 696.4571,301.4042 v 11.2252 l -11.2252,-25.3702 v -0.2833 l 11.2252,-25.3701 v 11.2252 z',
            vestibular: 'm 685.2319,312.6294 h 11.2252 l -11.2252,-25.3702 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            lingual: 'm 685.2319,261.6058 h 11.2252 l -11.2252,25.3701 h -28.5732 l -11.2252,-25.3701 h 11.2252 z',
        },
        cap: { x: '651.83258', y: '331.98969' },
        top: { x: '670.401', y: '257.53629' },
    },
    {
        id: 74,
        path: {
            all: 'm 707.7957,261.6058 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 719.0209,272.831 v 28.5732 h 28.5732 V 272.831 Z',
            mesial: 'm 707.7957,301.4042 v 11.2252 l 11.2252,-11.2252 V 272.831 l -11.2252,-11.2252 v 11.2252 z',
            distal: 'm 758.8193,301.4042 v 11.2252 L 747.5941,301.4042 V 272.831 l 11.2252,-11.2252 v 11.2252 z',
            vestibular: 'm 747.5941,312.6294 h 11.2252 l -11.2252,-11.2252 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            lingual: 'm 747.5941,261.6058 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '713.2218', y: '331.77371' },
        top: { x: '732.76318', y: '257.53629' },
    },
    {
        id: 75,
        path: {
            all: 'm 770.1579,261.6058 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 781.3831,272.831 v 28.5732 h 28.5732 V 272.831 Z',
            mesial: 'm 770.1579,301.4042 v 11.2252 l 11.2252,-11.2252 V 272.831 l -11.2252,-11.2252 v 11.2252 z',
            distal: 'm 821.1815,301.4042 v 11.2252 L 809.9563,301.4042 V 272.831 l 11.2252,-11.2252 v 11.2252 z',
            vestibular: 'm 809.9563,312.6294 h 11.2252 l -11.2252,-11.2252 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            lingual: 'm 809.9563,261.6058 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '776.51202', y: '331.98969' },
        top: { x: '795.12543', y: '257.53629' },
    },
    {
        id: 81,
        path: {
            all: 'm 457.6697,261.6058 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 468.8949,286.9758 v 0.2835 h 28.5732 v -0.2835 z',
            distal: 'm 457.6697,301.4042 v 11.2252 l 11.2252,-25.6535 v 0 l -11.2252,-25.3701 v 11.2252 z',
            mesial: 'm 508.6933,301.4042 v 11.2252 l -11.2252,-25.3702 v -0.2833 l 11.2252,-25.3701 v 11.2252 z',
            vestibular: 'm 497.4681,312.6294 h 11.2252 l -11.2252,-25.3702 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            lingual: 'm 497.4681,261.6058 h 11.2252 l -11.2252,25.3701 h -28.5732 l -11.2252,-25.3701 h 11.2252 z',
        },
        cap: { x: '465.15781', y: '331.98969' },
        top: { x: '482.6373', y: '257.53629' },
    },
    {
        id: 82,
        path: {
            all: 'm 395.3075,261.6058 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 406.5327,286.9758 v 0.2835 h 28.5732 v -0.2835 z',
            distal: 'm 395.3075,301.4042 v 11.2252 l 11.2252,-25.6535 v 0 l -11.2252,-25.3701 v 11.2252 z',
            mesial: 'm 446.3311,301.4042 v 11.2252 l -11.2252,-25.3702 v -0.2833 l 11.2252,-25.3701 v 11.2252 z',
            vestibular: 'm 435.1059,312.6294 h 11.2252 l -11.2252,-25.3702 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            lingual: 'm 435.1059,261.6058 h 11.2252 l -11.2252,25.3701 h -28.5732 l -11.2252,-25.3701 h 11.2252 z',
        },
        cap: { x: '401.61661', y: '331.98969' },
        top: { x: '420.27509', y: '257.53629' },
    },
    {
        id: 83,
        path: {
            all: 'm 332.9453,261.6058 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 344.1705,286.9758 v 0.2835 h 28.5732 v -0.2835 z',
            distal: 'm 332.9453,301.4042 v 11.2252 l 11.2252,-25.6535 v 0 l -11.2252,-25.3701 v 11.2252 z',
            mesial: 'm 383.9689,301.4042 v 11.2252 l -11.2252,-25.3702 v -0.2833 l 11.2252,-25.3701 v 11.2252 z',
            vestibular: 'm 372.7437,312.6294 h 11.2252 l -11.2252,-25.3702 h -28.5732 l -11.2252,25.3702 h 11.2252 z',
            lingual: 'm 372.7437,261.6058 h 11.2252 l -11.2252,25.3701 h -28.5732 l -11.2252,-25.3701 h 11.2252 z',
        },
        cap: { x: '339.1824', y: '331.98969' },
        top: { x: '357.9129', y: '257.53629' },
    },
    {
        id: 84,
        path: {
            all: 'm 270.5831,261.6058 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 281.8083,272.831 v 28.5732 h 28.5732 V 272.831 Z',
            distal: 'm 270.5831,301.4042 v 11.2252 l 11.2252,-11.2252 V 272.831 l -11.2252,-11.2252 v 11.2252 z',
            mesial: 'm 321.6067,301.4042 v 11.2252 L 310.3815,301.4042 V 272.831 l 11.2252,-11.2252 v 11.2252 z',
            vestibular: 'm 310.3815,312.6294 h 11.2252 l -11.2252,-11.2252 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            lingual: 'm 310.3815,261.6058 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '276.8472', y: '331.98969' },
        top: { x: '295.5506', y: '257.53629' },
    },
    {
        id: 85,
        path: {
            all: 'm 208.2209,261.6058 v 51.0236 h 51.0236 v -51.0236 z',
            occlusal: 'm 219.4461,272.831 v 28.5732 h 28.5732 V 272.831 Z',
            distal: 'm 208.2209,301.4042 v 11.2252 l 11.2252,-11.2252 V 272.831 l -11.2252,-11.2252 v 11.2252 z',
            mesial: 'm 259.2445,301.4042 v 11.2252 L 248.0193,301.4042 V 272.831 l 11.2252,-11.2252 v 11.2252 z',
            vestibular: 'm 248.0193,312.6294 h 11.2252 l -11.2252,-11.2252 h -28.5732 l -11.2252,11.2252 h 11.2252 z',
            lingual: 'm 248.0193,261.6058 h 11.2252 l -11.2252,11.2252 h -28.5732 l -11.2252,-11.2252 h 11.2252 z',
        },
        cap: { x: '214.41299', y: '331.98969' },
        top: { x: '233.1884', y: '257.53629' },
    },
];

export const odontogramNumbers = [
    [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28],
    [55, 54, 53, 52, 51, 61, 62, 63, 64, 65],
    [85, 84, 83, 82, 81, 71, 72, 73, 74, 75],
    [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38],
];
